import styled, { css } from 'styled-components';
import StyleGuide from 'src/style-guide';
import constants from 'src/constants';

const { ASPECT_RATIO } = constants.screenshot;

const containerTopPadding = 20;
const navButtonPadding = 24;

const ButtonCSS = css<{
  size: number;
}>`
  cursor: pointer;

  svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  }
`;

const NavigationButtonCSS = css<{
  size: number;
  disabled: boolean;
}>`
  position: absolute;
  display: flex;
  height: 75%;
  align-items: center;
  z-index: 1;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};

  svg {
    width: 50px;
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  }
`;

export const LightboxContainer = styled('div')`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 100px 200px;
`;

export const Mask = styled('div')`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  opacity: 0.6;
  backdrop-filter: blur(14px);
`;

export const PreviousButton = styled(StyleGuide.Icon)<{
  size: number;
}>`
  ${NavigationButtonCSS}

  left: -${({ size }) => size + navButtonPadding}px;
  transform: rotate(180deg);
`;

export const NextButton = styled(StyleGuide.Icon)<{
  size: number;
}>`
  ${NavigationButtonCSS}

  right: -${({ size }) => size + navButtonPadding}px;
`;

export const CloseButton = styled('div')<{
  size: number;
}>`
  ${ButtonCSS}

  position: absolute;
  top: 32px;
  right: 32px;
  z-index: 1;

  svg {
    g {
      fill: #ffffff;
    }
  }
`;

export const DownloadButton = styled('div')<{ size: number }>`
  position: absolute;
  bottom: -${({ size }) => size + containerTopPadding}px;
  right: 0;
  display: flex;
  flex-direction: row;
  padding: 4px 20px;
  height: ${({ size }) => size}px;
  border-radius: 4px;
  background-color: #247ddc;
  z-index: 1;
  cursor: pointer;

  a {
    line-height: 18px;
    font-size: 12px;
    color: white;
    &:hover,
    &:focus {
      color: white;
    }
  }
`;

export const ImageContainer = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  max-width: calc((100vh - 200px) * ${ASPECT_RATIO});
  width: 100%;
  justify-content: center;
`;

export const Image = styled('img')`
  user-select: none;
  z-index: 1;
`;
